import { render, staticRenderFns } from "./outgoing-call-recording.vue?vue&type=template&id=2951df60&"
import script from "./outgoing-call-recording.vue?vue&type=script&lang=js&"
export * from "./outgoing-call-recording.vue?vue&type=script&lang=js&"
import style0 from "./outgoing-call-recording.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports